import { Link } from 'react-router';
import { GuideTip } from './guide-layout';

const inlineLink =
  'font-medium text-brand-600 underline decoration-brand-300 underline-offset-2';

export function PhaseFiveGuideNotes() {
  return (
    <>
      <GuideTip variant="warning" title="Scope and legal boundary">
        Fixtyer prepares documents and is not a law firm. It provides general information, not
        legal advice or representation, and does not promise liability, notice, claim success or
        defeat of a Section 58 defence. FixMyStreet reports are leads to verify, not proof of
        notice.
      </GuideTip>
      <div className="mb-8 rounded-xl border border-surface-200 bg-surface-50 p-5 text-sm leading-relaxed text-surface-700">
        <p className="mb-3">
          This guidance covers England and Wales. Welsh Government manages motorways and trunk
          roads in Wales; local authorities manage other Welsh local roads. DfT council ratings
          cover England only and must not be applied to Wales.
        </p>
        <p className="mb-3">
          Do not stop on a motorway or live carriageway to take photographs. Protect people before
          collecting evidence and use an existing safe place away from moving traffic.
        </p>
        <p>
          Related resources:{' '}
          <Link to="/councils" className={inlineLink}>
            council reports
          </Link>
          ,{' '}
          <Link to="/data/council-road-maintenance-ratings" className={inlineLink}>
            the England-only ratings dataset
          </Link>
          , and the{' '}
          <Link to="/check" className={inlineLink}>
            free eligibility journey
          </Link>
          .
        </p>
      </div>
    </>
  );
}
